import React, { Dispatch, SetStateAction } from "react"
import Popup from "../../../../Ui/Popup"
import { useQuery } from "@apollo/client"
import { ButtonWrapper, ProviderContainer } from "./StatusPopup.styled"
import Status from "../../../../Ui/Status"
import PrimaryButton from "../../../../Ui/Buttons/PrimaryButton"
import { ReactComponent as RefreshIcon } from "../../../../../images/icons/arrow-rotate-left-thick.svg"
import GET_RELEASE from "../../../../../graphql/queries/order/GetRelease"

type Props = {
  setShowStatusPopup: Dispatch<SetStateAction<boolean>>
  releaseId: string
  refetchOrder: () => void
}

const StatusPopup = ({ setShowStatusPopup, releaseId, refetchOrder }: Props) => {
  const { data, refetch, loading } = useQuery(GET_RELEASE, { variables: { releaseId } })

  const release = data?.Order?.release

  return (
    <Popup
      title={"Provider status"}
      handleCloseClick={() => {
        refetchOrder()
        setShowStatusPopup(false)
      }}
      handleOkClick={() => {
        refetchOrder()
        setShowStatusPopup(false)
      }}
      buttonText={"Ok"}
    >
      <div>
        <ButtonWrapper>
          <PrimaryButton handleClick={() => refetch()} loading={loading}>
            <RefreshIcon />
            Refresh status
          </PrimaryButton>
        </ButtonWrapper>
        {release?.bonus && (
          <ProviderContainer>
            <b>Bonus</b>
            <Status status={release?.bonusProvider?.status?.current} />
          </ProviderContainer>
        )}
        {release?.giftCards.length > 0 && (
          <ProviderContainer>
            <b>Gift card</b>
            <Status status={release?.giftCardProvider?.status?.current} />
          </ProviderContainer>
        )}
        {release?.paymentProvider && (
          <ProviderContainer>
            <b>Payment</b>
            <Status status={release?.paymentProvider?.status?.current} />
          </ProviderContainer>
        )}
      </div>
    </Popup>
  )
}

export default StatusPopup
